var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',[_c('v-card-title',[_vm._v(" Not Implemented ")]),_c('v-card-text',[_vm._v(" This feature has not been implemented yet. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }